<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Código:</label>
			<div class="col-sm-5">
				<input type="number"
						name="id"
						:class="{'is-invalid' : errors.has('id')}"
						v-model="form.id"
						disabled="disabled"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('id')">{{ errors.first('id') }}</span>
			</div>
		</div>
		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
			<div class="col-sm-10">
				<input type="text"
						name="nome"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('nome')}"
						v-model="form.nome"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<textarea type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm"></textarea>
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Template:</label>
			<div class="col-sm-10">
				<input type="text"
						name="template"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('template')}"
						v-model="form.template"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('template')">{{ errors.first('template') }}</span>
			</div>
		</div>


		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">E-mail:</label>
			<div class="col-sm-6">

				<toggle-button
							v-model.trim="form.email"
							:width="70"
							:height="30"
							:sync="true"
							:value="form.email"
							:labels="{checked: 'SIM', unchecked: 'NÃO'}"
							:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">SMS:</label>
			<div class="col-sm-6">

				<toggle-button
							v-model.trim="form.sms"
							:width="70"
							:height="30"
							:sync="true"
							:value="form.sms"
							:labels="{checked: 'SIM', unchecked: 'NÃO'}"
							:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Perfis:</label>
			<div class="col-sm-10">
				<div style="max-height:250px; overflow: auto">
					<table class="table table-sm table-hover table-bordered" style="margin-bottom:0px">
						<tbody>
							<tr v-for="(item, index) in perfis" :class="{'table-success' : item._clicked}" @click="clickSelecionado(index)" :key="index" style="cursor:pointer">
								<td>
									<fa-icon icon="check-circle" v-if="item._clicked" />
									<fa-icon :icon="['far', 'circle']" v-else/>
									{{item.descricao}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<style>
.ir {
	position: absolute;
	right: 20px;
	top: 4px;
}
</style>


<script>
import _ from 'lodash'
import axios from '../../../routers/axios';
export default {
	data() {
		return {
			perfis: [],
			editar: false,
			form: {
				id: "",
				descricao: "",
				nome: "",
				sms: false,
				email: false,
				template: "",
				perfis: []
			}
		};
	},

	mounted() {},

	methods: {

		carregaDados(perfis, item) {
			this.perfis = perfis.map(item => {
				item._clicked = false;
				return item;
			});

			if (item != null) {
				this.editar = true;
				this.form.id = item.id;
				this.form.descricao = item.descricao;
				this.form.sms = item.sms;
				this.form.email = item.email;
				this.form.nome = item.nome;
				this.form.template = item.template;
				this.form.perfis = item.perfis.map((item, idx) => {
					let index = _.findIndex(this.perfis, p => {
						return p.id == item.id;
					});
					this.clickSelecionado(index);
					return item;
				});
			}
		},

		validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.salva();
				}
			});
		},

		clickSelecionado(index) {
			this.perfis[index]._clicked = !this.perfis[index]._clicked;
			this.$forceUpdate();
		},

		salva() {
			let perfis = _.filter(this.perfis, o => {
				return o._clicked;
			});

			var data = {
				id: this.form.id == "" ? 0 : this.form.id,
				descricao: this.form.descricao,
				nome: this.form.nome,
				sms: this.form.sms,
				email: this.form.email,
				template: this.form.template,
				perfis: perfis.map(item => {
					return item.id;
				})
			};

			this.$notify.loadIn('Salvando')

			if (this.editar) {
				axios.put(this._getUrl(`api/notificacaoconfig/${this.form.id}`), data).then(response => {
					this.$emit("item-salvo", response.data);
					this.form.id = response.data.id;
				});
			} else {
				axios.post(this._getUrl("api/notificacaoconfig"), data).then(response => {
					this.editar = true;
					this.$emit("item-salvo", response.data);
					this.form.id = response.data.id;
				});
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/adm/notificacao-config/cadastro.vue